export const SW_TAG_GENERATE_AND_SAVE_CONTEXT = 'generate-and-save-context'
export const SW_TAG_GENERATE_AND_SAVE_MOMENTS_CHUNKS =
  'generate-and-save-moments-chunks'
export const SW_TAG_GENERATE_AND_SAVE_TAGS_AND_EMOTION =
  'generate-and-save-tags-and-emotion'
export const SW_TAG_ENCRYPT_AND_SAVE_IMAGES = 'encrypt-and-save-images'
